import * as outdatedBrowserRework from 'outdated-browser-rework';

outdatedBrowserRework({
  browserSupport: {
    'Chrome': 57, // Includes Chrome for mobile devices
    'Edge': 31,
    'Safari': 10,
    'Mobile Safari': 10,
    'Firefox': 50,
    'IE': false
  },
  requireChromeOnAndroid: true
})

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'hammerjs';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts